/**
 * Per-env fallback URL for the rewrite applicant portal.
 *
 * Only used when a STORE_MIGRATED_TO_REWRITE / rewrite_redirect payload from
 * the legacy API has `redirect_url: null` (env var not provisioned server-side).
 * Always prefer the server-provided `redirect_url` when present.
 */
export const getRewriteApplicantPortalUrl = (): string => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'local':
    case 'development':
      return 'https://sim.client.formpiper-dev.com';
    case 'production':
    default:
      // TODO(beta-golive): production rewrite applicant portal URL is TBD —
      // confirm with Alex. Until then the server-provided redirect_url is the
      // only reliable production target; this fallback points at the rewrite
      // sim portal and MUST be updated before a production store is flipped.
      return 'https://sim.client.formpiper-dev.com';
  }
};
